import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";

const ALLOWED_TO_CREATE_QUERY_KEY = "ALLOWED_TO_CREATE_QUERY_KEY";

export const useGetIsEnoughCreditsToCreateRTQuery = (projectId: string | undefined, enabled = true) => {
    const isEnabled = Boolean(projectId && enabled);

    return useQuery({
        queryKey: [ALLOWED_TO_CREATE_QUERY_KEY, projectId],
        queryFn: async () => {
            if (projectId == null || projectId === "") {
                return undefined;
            }

            const { rankTracker } = createActivationApi();

            return await rankTracker.getIsEnoughCreditsToCreate(projectId);
        },
        refetchOnWindowFocus: false,
        enabled: isEnabled,
    });
};
